export const emailsConstants = {
  LOAD_EMAILS: "LOAD_EMAILS",
  LOAD_EMAILS_SUCCESS: "LOAD_EMAILS_SUCCESS",
  LOAD_EMAILS_FAILURE: "LOAD_EMAILS_FAILURE",
  LOAD_EMAILS_REQUEST: "LOAD_EMAILS_REQUEST",
  UPDATE_EMAIL: "UPDATE_EMAIL",
  DELETE_EMAIL: "DELETE_EMAIL",
  NEW_MAIL: "___NEW___MAIL___df97806b-d93e-486b-add9-78c056d6ad11",
};
